import { TypeModeApp } from "./utilities/enum";

// constants.js
const MODE = process.env.VUE_APP_MODE || TypeModeApp.DEVELOPMENT;

const APP_BACKEND_DEV = process.env.VUE_APP_BACKEND_DEV;
const APP_BACKEND_PROD = process.env.VUE_APP_BACKEND_PROD;

const APP_BACKEND_ESG_DEV = process.env.VUE_APP_BACKEND_ESG_DEV;
const APP_BACKEND_ESG_PROD = process.env.VUE_APP_BACKEND_ESG_PROD;

export const APP_ICORE_SERVICE = process.env.VUE_APP_ICORE_SERVICE_URL;

const BE_ESB_DEV = process.env.VUE_APP_API_ESB_DEV;
const BE_ESB_PROD = process.env.VUE_APP_API_ESB_PROD;
const TOKEN_ESB_PROD = process.env.VUE_APP_TOKEN_ESB_PROD;
const TOKEN_ESB_DEV = process.env.VUE_APP_TOKEN_ESB_DEV;

const CLIENT_ID_DEV = process.env.VUE_APP_KEYCLOAK_CLIENT_ID_DEV;
const CLIENT_ID_PROD = process.env.VUE_APP_KEYCLOAK_CLIENT_ID_PROD;

export const BE_ESB =
  MODE === TypeModeApp.PRODUCTION ? BE_ESB_PROD : BE_ESB_DEV;
export const TOKEN_ESB =
  MODE === TypeModeApp.PRODUCTION ? TOKEN_ESB_PROD : TOKEN_ESB_DEV;
export const API_BASE_URL =
  MODE === TypeModeApp.PRODUCTION ? APP_BACKEND_PROD : APP_BACKEND_DEV;
export const APP_BACKEND_ESG =
  MODE === TypeModeApp.PRODUCTION ? APP_BACKEND_ESG_PROD : APP_BACKEND_ESG_DEV;
export const CLIENT_ID =
  MODE === TypeModeApp.PRODUCTION ? CLIENT_ID_PROD : CLIENT_ID_DEV;

//endpoint CMS
export const CMS_GET_LISTKONTRAKTOR = 'cms/kontraktor/list';
export const CMS_GET_DETAILKONTRAKTOR = 'cms/kontraktor/detail?id_kontraktor=';
export const CMS_SET_KONTRAKTOR = 'cms/kontraktor/set';
export const CMS_CHECK_INISIAL = "cms/kontraktor/check-inisial";
export const CMS_GET_OTP = 'cms/grant/kontraktor';
export const CMS_KONTRAKTOR = 'cms/kontraktor/';
export const CMS_SEND_OTP = 'cms/grant/otp';
export const CMD_POST_LOGIN_ISAFE = "cms/grant/isafe"
export const CMS_GET_INTERNAL_KONTRAKTOR = "cms/kontraktor/list/internal";
export const CMS_GET_USER_LIST = "cms/grant/user/list";
export const CMS_GET_USER_UPDATE = "cms/grant/user/update";
export const CMS_USER_REGISTER = "cms/grant/register";
export const CMS_CHECK_USER_EMAIL = "cms/grant/user/check";
export const CMS_VIEW_IMAGE = "cms/file/view/img?filename=";
export const CMS_VIEW_FILE = "cms/view/";
export const CMS_UPLOAD = "cms/upload";
export const CMS_UPLOAD_USECASE = "cms/upload/usecase";
export const CMS_UPLOAD_KBLI = "cms/upload/kblis";
export const CMS_UPLOAD_FILE_PK = "cms/upload/file"; // file persyaratan khusus form imkp (7, sio)
export const CMS_GET_UPLOADED_FILENAME = "cms/upload/fetch_file_map";
export const CMS_DOWNLOAD = "cms/download/";
export const CMS_DASHBOARD = "cms/dashboard";
export const CMS_DASHBOARD_SIO = "cms/dashboard/sio";
export const CMS_GET_BIDANG = "cms/bidang/list";
export const CMS_SET_KONTRAK = "cms/contract/set";
export const IUJP_EXP = "cms/kontraktor/iujp/exp";
export const CMS_GET_LIST_SUB_KONTRAKTOR = "cms/kontraktor/sub-kontraktors";
export const CMS_KONTRAK = "cms/contract";
export const CMS_DELETE_KONTRAK = "cms/contract/delete";
export const CMS_DELETE_KBLI = "cms/kbli";
export const CMS_SIO_SET_KELENGKAPAN = "cms/sio/kelengkapan";
export const CMS_GET_KELENGKAPAN_SIO = "cms/sio/kelengkapan?sio="; // set sio id
export const CMS_GET_SIOID = "cms/sio?kont_id="; // get sio id
export const CMS_SET_SIOID = "cms/sio/set"; // set sio id
export const CMS_SIO_GET_DASHBOARD = "cms/sio/dashboard?sio_id="; // get sio dashboard
export const CMS_SIO_SET_PJOPENGESAHAN = "cms/sio/pjo_pengesahan/set"; // form 1
export const CMS_SIO_GET_PJOPENGESAHAN = "cms/sio/pjo_pengesahan/get?id="; // form 1
export const CMS_SIO_SET_PJODET = "cms/sio/pjodetail/set"; //form 2
export const CMS_SIO_GET_PJODET = "cms/sio/pjodetail?id="; // form 2
export const CMS_SIO_SET_PERNYATAANPJO = "cms/sio/pernyataanpjo/set"; //form 3
export const CMS_SIO_GET_PERNYATAANPJO = "cms/sio/pernyataanpjo/get?id="; // form 3
export const CMS_SIO_SET_KEBENARAN_DOKUMEN = "cms/sio/kebenarandokumen/set"; //form 4
export const CMS_SIO_GET_KEBENARAN_DOKUMEN = "cms/sio/kebenarandokumen/get?id="; // form 4
export const CMS_SIO_SET_DUKUNGAN_PIMPINAN = "cms/sio/suratdukungan/set"; //form 5
export const CMS_SIO_GET_DUKUNGAN_PIMPINAN = "cms/sio/suratdukungan/get?id="; // form 5
export const CMS_SIO_SET_IMKP = "cms/sio/izinproyek/set"; //form 7
export const CMS_SIO_GET_IMKP = "cms/sio/izinproyek/get?id="; //form 7
export const CMS_SIO_DEL_PRESENTASI = "cms/sio/presentasi?id="; //delete file form 6
export const CMS_SIO_UPLOAD_PERSETUJUAN = "cms/sio/upload/persetujuan";
export const CMS_SIO_LIST = "cms/sio/filter";
export const CMS_VIEW_DOCUMENT = "cms/view/";
export const CMS_SET_SIO_INACTIVE = "cms/sio/inactive";
export const CMS_SET_SIO_CHANGE_TYPE = "cms/sio/change/type";
export const CMS_GET_APP_CONFIGS = "cms/app-configs";
export const CMS_GET_SIO_EXPIRING_LIST = "cms/sio/expiring-list";
export const CMS_DELETE_KONTRAKTOR = "cms/kontraktor/delete";
export const CMS_SET_JADWALNILAI = "cms/penilaian/penjadwalan/set";
export const CMS_GET_ASPEKNILAI = "cms/penilaian/aspek";
export const CMS_GET_JADWALNILAI = "cms/penilaian/penjadwalan/get?id=";
export const CMS_GET_JADWALHISTORY = "cms/penilaian/penjadwalan/history";
export const CMS_GET_SIOCUSTODIAN = "cms/penilaian/kustodian"; //get list sio custodian
export const CMS_GET_ASPEKPENJADWALAN = "cms/penilaian/aspek/penjadwalan";
export const CMS_GET_PENILAIANDETAIL = "cms/penilaian/detail";
export const CMS_GET_HISTORY_PENILAIAN = "cms/penilaian/history/detail";
export const CMS_GET_HISTORY_PENILAIAN_RESUME =
  "cms/penilaian/history/resume/detail";
export const CMS_GET_HISTORY_PANJADWALAN = "cms/penilaian/history/penjadwalan";
export const CMS_GET_PENILAIANASPEK = "cms/penilaian/aspek/detail";
export const CMS_SET_PENILAIAN = "cms/penilaian/submit";
export const CMS_GET_PENILAIAN_HISTORY = "cms/penilaian/penjadwalan/history";
export const CMS_GET_PENILAIAN_RESUME = "cms/penilaian/resume";
export const CMS_GET_PENILAIAN_RESUME_SUBMIT = "cms/penilaian/resume/submit";
export const CMS_GET_KONTRAKTOR_JADWALNILAI =
  "cms/penilaian/penjadwalan/kontraktor/get?id=";
export const CMS_SET_NC = "cms/penilaian/nc/submit";
export const CMS_GET_NC_LIST = "cms/penilaian/nc/list";
export const CMS_GET_NC_DETAIL = "cms/penilaian/nc/detail";
export const CMS_SET_STATUS_SIO = "cms/sio/status";
export const CMS_GET_NOTIF = "cms/notification";
export const CMS_GET_NOTIF_KONTRAKTOR = "cms/notification/kontraktor";
export const CMS_GET_CHANGES_KONTRAKTOR = "cms/changes/fetch";
export const CMS_SET_CHANGES_KONTRAKTOR = "cms/changes/apply";
export const CMS_GET_CHANGES_LIST = "cms/changes/list";
export const CMS_GET_CHANGES_INFORMATION = "cms/changes/information";
export const CMS_GET_LIST_SUPPLIER = "cms/supplier/list";
export const CMS_GET_DETAIL_SUPPLIER = "cms/supplier/kontraktor?id=";
export const CMS_SET_SUPPLIER = "cms/supplier/set";
export const CMS_LIST_IMKP = "cms/imkp";
export const CMS_IMKP = "cms/imkp/izin-kontrak";
export const CMS_IMKP_DETAIL = "cms/imkp/detail";
export const CMS_GET_IMKP_ACTIVE = "cms/imkp/list-active";
export const CMS_SET_IMKP_OHS = "cms/imkp/trigger-ohs";
export const CMS_GET_IMKP_BY_KONTRAKTOR = "cms/imkp/izin-kontrak/by-kontraktor";
export const CMS_GET_IMKP_REQUEST = "cms/imkp/list-trigger-ohs/request";
export const CMS_SET_IMKP_REQUEST = "cms/imkp/request/action";
export const CMS_SET_IMKP = "cms/imkp/ppjkp/request";
export const CMS_SET_VERIFY = "cms/imkp/ppjkp/verify";
export const CMS_SET_IMKP_PUBLISH = "cms/imkp/upload/publish";
export const CMS_SET_BAST = "cms/imkp/set-bast";
export const CMS_SET_BAST_ADMIN = "cms/imkp/set-bast-ohs";
export const CMS_SET_BAST_WARRANTY = "cms/imkp/set-bast-warranty";
export const CMS_SET_BAST_WARRANTY_ADMIN = "cms/imkp/set-bast-warranty-ohs";
export const CMS_SET_IMKP_AMANDEMEN_KONTRAKTOR =
  "cms/imkp/amandement-kontraktor";
export const CMS_GET_IMKP_HISTORY = "cms/imkp/history-amandement/list";
export const CMS_GET_IMKP_TEMP = "cms/imkp/amandemen-temp";
export const CMS_SET_IMKP_AMANDEMEN_OHS = "cms/imkp/amandement-ohs";
export const CMS_DELETE_IMKP = "cms/imkp/delete";
export const CMS_GET_DATA_NC = "cms/sio/generate-pdf-nc?id=";
export const CMS_SIO_SET_SIOPENGESAHAN = "cms/sio/upload/siopublish";
export const CMS_SET_SUBKONTRAKTOR = "cms/kontraktor/subkontraktor/set";
export const CMS_SUB_KONTRAKTOR = "cms/kontraktor/subkontraktor";
export const CMS_SET_KONTRAKTOR_PJP = "cms/kontraktor/pjp/set";
export const CMS_LIST_KONTRAKTOR_INACTIVE = "cms/kontraktor/list/in-active";
export const CMS_SET_KONTRAKTOR_REACTIVE = "cms/kontraktor/reactivate";
export const CMS_GET_VERIFIKASI_DATA = "cms/kontraktor/checkVerifikasiData?id=";
export const CMS_SET_VERIFIKASI_DATA = "cms/kontraktor/submitVerifikasiData";
export const CMS_GET_DASHBOARD_IMKP = "cms/imkp/dashboard";
export const CMS_GET_USER_DETAIL = "cms/grant/user/detail";
export const CMS_DOWNLOAD_ESIGN = "cms/sio/download/eSign/file";
export const CMS_SET_WORK_AREA = "cms/kontraktor/edit/work-area";
export const CMS_INSERT_NEW_SUB = "cms/kontraktor/sub-contractor/insert";
export const CMS_EXPORT_KONTRAKTOR = "cms/kontraktor/export-kontraktor";
export const CMS_NOTIFICATION_ESG = "cms/notification/esg-report";
export const CMS_EXPORT_REPORT_ESG = "cms/excel";

// SSE
export const CMS_SSE_STREAM = "cms/sse/stream";

// MAINTENANCE MODE
export const CMS_MAINTENANCE_MODE = "cms/notification/maintenance";

// endpoint ESB (SIMPER)
export const ESB_GET_TOKEN = "external/getToken";
export const ESB_GET_SIMPER = "external/simperlist/getAll";
export const ESB_GET_DEPARTMENT = "external/simperlist/getDepartment";

export const ESB_GET_LOCATION = "external/location";
export const ESB_GET_SUBLOCATION = "external/sub-location";

export const APP_VERSION = "0.0.1";

export const VIEW_PHOTO_PROFILE_ISAFE =
  "esimper/employee/preview-photo-profile?isafeno=";
